

import React from 'react';

const leavesData = [
  { name: "Total Workforce", color: '#FF00FF' },
  { name: "Present Workforce", color: '#FFFF99' },
  { name: "Absent Workforce", color: '#99FF99' },
  { name: "Late Arrivals", color: '#FF9933' },
  { name: "In Leave", color: '#CC99FF' },
];

const LeaveDetails = () => {
  return (
    <div className="border-2 border-black p-4 w-[200px] rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Employee Information</h2>
      <ul>
        {leavesData.map((leave, index) => (
          <li key={index} className="flex items-center mb-2">
            <span className={`w-4 h-4 rounded-full mr-2`} style={{backgroundColor: `${leave.color}`}} />
            <span>{leave.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeaveDetails;
